// 	export default  [
// xs	<768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// sm	≥768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// md	≥992px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// lg	≥1200px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// xl	≥1920px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})
// // ]

export default [
	{ label:'药品名称：',xs:12,sm:12,md:6,lg:8,xl:8,type:'selectFirst',modelValue:'invId',prop:'invId',disabled:true,op:'nameOption'},
	{ label:'药品规格：',xs:12,sm:12,md:6,lg:8,xl:8,type:'input',modelValue:'drugSpec',disabled:true,op:'selectOption'},
	{ label:'包装规格：',xs:12,sm:12,md:6,lg:8,xl:8,type:'input',modelValue:'pacSpec',disabled:true},

	{ label:'库存数量：', xs:12,sm:12,md:4,lg:8,xl:8,type:'input',modelValue:'purcCnt',disabled:true},
	{ label:'零售单价：', xs:12,sm:12,md:4,lg:8,xl:8,type:'input',modelValue:'salePric',disabled:true},
	{ label:'成本单价：',xs:12,sm:12,md:4,lg:8,xl:8,type:'input',modelValue:'retnPric',disabled:true},
	
	{ label:'出库数量：',xs:12,sm:12,md:6,lg:8,xl:8,type:'inputNum',modelValue:'retnCnt',placeholder:''},
	{ label:'生产厂家：',xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'prodentpName',op:'ManufacturerOptions',disabled:true},
	{ label:'生产批号：',xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'manuLotnum',placeholder:''},
	// { label:'有效日期：',  xs:12,sm:12,md:6,lg:5,xl:5,type:'select',modelValue:'expyDate',placeholder:'',op:'expyDateOptions'},
	
	// { label:'',xs:3,sm:3,md:3,lg:3,xl:3,type:'input',modelValue:'numZ',placeholder:'',disabled:'true'},
	{ label:'加入' ,xs:24,sm:24,md:24,lg:4,xl:4,type:'btn',disabled:true,modelValue:'educationalBackground',placeholder:'',},
]

